import { FETCH_WALLET_TXNS_SUCCESS } from "../actionTypes";
  
const initialState = {
	data: {},
	error: {}
};

const WalletTxns = (state = initialState, action) => {
	switch (action.type) {
		case FETCH_WALLET_TXNS_SUCCESS:
			return { ...state, data: { ...action.data } };
		default:
			return state;
	}
};
  
export default WalletTxns;